/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { useTranslation } from 'react-i18next'
import ErrorMessage from 'components/share/ErrorMessage'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import { InsightCount } from 'schemas/action/InsightCountSchema'
import { WidgetGuard } from 'features/types'

const TrendingEmptyResultGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetData = useDashboardWidgetData<InsightCount>(widgetId)
  const { t } = useTranslation()

  const entries = widgetData?.data?.[0]?.results?.[0]?.data?.insights?.[0]?.dataset?.flatMap(
    (result) => result.set
  )

  if (entries?.length === 0) return <ErrorMessage>{t('noDataFoundInWidget')}</ErrorMessage>

  return children
}

export default TrendingEmptyResultGuard
